<kiosk-wizard [step]="4">
  <div class="kiosk-hw100">
    <kiosk-template
      mainTitle="app.components.wizard.steps.scan-qr-code-success.scan-success"
      subtitle="app.components.wizard.steps.scan-qr-code-success.confirm-details"
      svg="success"
    >
    </kiosk-template>
    <kiosk-next (nextSelected)="navigate()"></kiosk-next>
  </div>
</kiosk-wizard>
